import { GameStatus } from '../game/types';

export const betsOpenStatuses: Array<GameStatus | string> = [GameStatus.PlaceYourBets, GameStatus.LastBets];
